import React from "react"
import { useSelector } from "react-redux"
import { useIntl } from "react-intl"
import { getSubsidies } from "#/redux/reducers/subsidies"
import { getCategoryName } from "../ReimbursementCategoryMessages"
import { Box } from "@carrotfertility/carotene-core"
import { getCategoryCoverage } from "../../../../utils/CategoryCoverage"
import { Subsidy } from "#/lib/carrot-api/types/Subsidy"
import { getBenefitGuideCategoryGroups } from "../../molecules/subsidyCategoryGroups"
import { CategoryAccordion } from "../../molecules/CategoryAccordion"
import { BenefitGuideCategoryDetails } from "./BenefitGuideCategoryDetails"

const PayingForCareCoverageDetails = (): JSX.Element => {
  const intl = useIntl()
  const subsidies: Subsidy[] = useSelector(getSubsidies)
  const groups = getBenefitGuideCategoryGroups(subsidies ?? [])
  const guideSubsidies = groups.flat()

  if (groups.length === 0) return null
  if (groups.length === 1)
    return (
      <Box sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.md })}>
        <BenefitGuideCategoryDetails group={groups[0]} guideSubsidies={guideSubsidies} singleCategory />
      </Box>
    )

  const hasQmeCategory = getCategoryCoverage(guideSubsidies).qme
  return (
    <>
      {groups.map((group) => {
        const category = group[0].reimbursementCategoryNameMessageKey
        return (
          <CategoryAccordion
            key={category}
            id={`benefit-guide-${category}`}
            title={intl.formatMessage(getCategoryName(category, hasQmeCategory))}
            titleVariant="h2"
            headingComponent="h2"
          >
            <BenefitGuideCategoryDetails group={group} guideSubsidies={guideSubsidies} />
          </CategoryAccordion>
        )
      })}
    </>
  )
}

export { PayingForCareCoverageDetails }
